import Prism from 'prismjs';
import Normalizer from 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace';

var Component = {
render: function(){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pre',{class:_vm.codeClass},[_c('code',{class:_vm.codeClass,domProps:{"innerHTML":_vm._s(_vm.highlightedCode)}})])},
staticRenderFns: [],
		data () {
			return {
				instance: Prism
			}
		},
		props: [
			'code',
			'language',
			'plugins'
		],
		computed: {
			highlightedCode () {
				return this.instance.highlight(this.normalizeWhitespace(this.code), this.instance.languages[this.language]);
			},
			codeClass () {
				return 'language-' + this.language
			},
			pluginConfig () {
				return this.plugins || {};
			}
		},
		methods: {
			normalizeWhitespace (code) {
				if (this.pluginConfig.whitespace) {
					const normalizer = new Normalizer(this.pluginConfig.whitespace);
					return normalizer.normalize(code);
				}
				return code;
			}
		}
	};

var Directive = {
	update: (el, binding) => {
		const { arg, modifiers } = binding;
		el.innerHTML = Prism.highlight(el.innerHTML, Prism.languages[arg]);
	}
};

var index = {
	install(Vue, options) {
		Vue.component("prism", Component);
		Vue.directive("prism", Directive);
	}
};

export default index;
